const sidebarData = [
    {
        title: "My Classes",
        path: "dashpage/myclasses",
        // icon: "bi bi-speedometer2",
    },
    {
        title: "My Progs",
        path: "dashpage/myprogs",
        // icon: "bi bi-bell",
    },
    {
        title: "My Doubts",
        path: "dashpage/mydoubts",
        // icon: "bi bi-bell",
    },
    {
        title: "My Tests",
        path: "dashpage/mytests",
        // icon: "bi bi-patch-check",
    },
    {
        title: "My Payment",
        path: "dashpage/myPayment",
        // icon: "bi bi-patch-check",
    },
    {
        title: "Change Password",
        path: "dashpage/changePassword",
        // icon: "bi bi-patch-check",
    },
    {
        title: "Take self assessment test",
        path: "dashpage/test",
        // icon: "bi bi-patch-check",
    },
    {
        title: "My Feedback (After course)",
        path: "dashpage/myFeedback",
        // icon: "bi bi-patch-check",
    },
]

export default sidebarData